import { websocket, type SubmitScoringMetricsPayload } from '@playcastdotio/Messaging';
import type { IRealtimeService } from '../../../services/realtime/IRealtimeService';

/**
 * Submits raw metrics to realtime-api over WebSocket. Defers on disconnect
 * and flushes on reconnect. Server dedupes on `(machineId, clientTimestamp)`.
 */
export class MetricsSubmissionManager {
  private pending: SubmitScoringMetricsPayload | null = null;
  private unsubscribeReconnect: (() => void) | null = null;

  constructor(
    private readonly realtime: IRealtimeService,
    private readonly onSubmitted: (payload: SubmitScoringMetricsPayload) => void,
  ) {}

  submit(payload: SubmitScoringMetricsPayload): void {
    if (!this.realtime.isConnected()) {
      this.pending = payload;
      if (!this.unsubscribeReconnect) {
        this.unsubscribeReconnect = this.realtime.onConnected(() => this.flushPending());
      }
      return;
    }
    this.send(payload);
  }

  private flushPending(): void {
    const pending = this.pending;
    this.pending = null;
    if (this.unsubscribeReconnect) {
      this.unsubscribeReconnect();
      this.unsubscribeReconnect = null;
    }
    if (pending) this.send(pending);
  }

  private send(payload: SubmitScoringMetricsPayload): void {
    const message = websocket.gamingScore.generators.submitScoringMetrics(payload);
    this.realtime.sendMessage(message);
    this.onSubmitted(payload);
  }
}
